import axiosInstance from '../axiosInstance';

const getCompanyCodesAPI = async () => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/payment-document/company-codes`;
    return await axiosInstance.get(url);
};
// const createPaymentInformationAPI = async (data) => {
//     const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/payment-document/payment-information`;
//     return await axiosInstance.post(url, data);
// };
const updatePaymentInformationAPI = async (paymentDocumentId, data) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/payment-document/payment-information/${paymentDocumentId}`;
    return await axiosInstance.put(url, data);
};
const updatePaymentDocumentTypeAPI = async (paymentDocumentId, data) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/payment-document/payment-document-type/${paymentDocumentId}`;
    return await axiosInstance.put(url, data);
};

const getAllRequestsForPaymentDocumentAPI = async (params) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/payment-document/requests/list` + params;
    return await axiosInstance.get(url);
};
const addRequestsToPaymentDocumentAPI = async (data) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/payment-document/requests`;
    return await axiosInstance.post(url, data);
};
const updateRequestsOfPaymentDocumentAPI = async (paymentDocumentId, data) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/payment-document/${paymentDocumentId}/requests`;
    return await axiosInstance.post(url, data);
};
const getRequestsOfPaymentDocumentAPI = async (paymentDocumentId) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/payment-document/${paymentDocumentId}/requests`;
    return await axiosInstance.get(url);
};
const removeRequestsFromPaymentDocumentAPI = async (paymentDocumentId, data) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/payment-document/${paymentDocumentId}/requests/delete`;
    return await axiosInstance.post(url, data);
};
const getAllPaymentDocumentsAPI = async (params) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/payment-document` + params;
    return await axiosInstance.get(url);
};
const getPaymentDocumentByIdAPI = async (id) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/payment-document/` + id;
    return await axiosInstance.get(url);
};
const uploadPaymentDocumentAttachmentAPI = async (paymentDocumentId, type, data) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/payment-document/${paymentDocumentId}/attachments/${type}`;
    return await axiosInstance.post(url, data, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};
const getAttachmentsOfPaymentDocumentAPI = async (paymentDocumentId) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/payment-document/${paymentDocumentId}/attachments`;
    return await axiosInstance.get(url);
};
const downloadPaymentDocumentAttachmentAPI = async (attachmentId) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/payment-document/attachments/${attachmentId}`;
    return await axiosInstance.get(url, {
        responseType: 'blob',
    });
};
const deletePaymentDocumentAttachmentAPI = async (attachmentId) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/payment-document/attachments/${attachmentId}`;
    return await axiosInstance.delete(url);
};
const getAllStatusOfPaymentDocumentAPI = async (paymentDocumentId) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/payment-document/${paymentDocumentId}/status`;
    return await axiosInstance.get(url);
};
const submitPaymentDocumentAPI = async (paymentDocumentId) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/payment-document/${paymentDocumentId}/submit`;
    return await axiosInstance.post(url);
};
const createPaymentDocumentCommentAPI = async (paymentDocumentId, body) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/payment-document/${paymentDocumentId}/comment`;
    return await axiosInstance.post(url, body);
};
const getPaymentDocumentCommentAPI = async (paymentDocumentId) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/payment-document/${paymentDocumentId}/comment`;
    return await axiosInstance.get(url);
};
const deletePaymentDocumentCommentAPI = async (commentId) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/payment-document/comment/${commentId}`;
    return await axiosInstance.delete(url);
};
const getPaymentDocumentFilterOptionsAPI = async () => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/payment-document/filter-options`;
    return await axiosInstance.get(url);
};
const downloadPaymentDocumentReportAPI = async (params) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/payment-document/report/download` + params;
    return await axiosInstance.get(url, {
        responseType: 'blob',
    });
};
const rejectPaymentDocumentReview = async (paymentDocumentId) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/payment-document/${paymentDocumentId}/reject`;
    return await axiosInstance.post(url);
};
const cancelPaymentDocumentProcessing = async (paymentDocumentId) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/payment-document/${paymentDocumentId}/cancel`;
    return await axiosInstance.post(url);
};

const cancelPaymentDocument = async (paymentDocumentId, body) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/payment-document/${paymentDocumentId}/cancel-payment`;
    return await axiosInstance.post(url, body);
};
const acceptPaymentDocumentReview = async (paymentDocumentId, body) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/payment-document/${paymentDocumentId}/accept`;
    return await axiosInstance.post(url, body);
};
const approveReversalOfRequestInPaymentDocument = async (paymentDocumentId, requestId, sapReversalCode) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/payment-document/${paymentDocumentId}/request/${requestId}/approve-reversal`;
    return await axiosInstance.post(url, { sapReversalCode });
};
const rejectReversalOfRequestInPaymentDocument = async (paymentDocumentId, requestId) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/payment-document/${paymentDocumentId}/request/${requestId}/reject-reversal`;
    return await axiosInstance.post(url);
};
const syncPaymentDocumentAPI = async (paymentDocumentId) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/payment-document/${paymentDocumentId}/sync`;
    return await axiosInstance.post(url);
};
const deletePaymentDocumentAPI = async (paymentDocumentId) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/payment-document/${paymentDocumentId}`;
    return await axiosInstance.delete(url);
};
export default {
    getCompanyCodesAPI,
    // createPaymentInformationAPI,
    updatePaymentInformationAPI,
    updatePaymentDocumentTypeAPI,
    getAllRequestsForPaymentDocumentAPI,
    addRequestsToPaymentDocumentAPI,
    updateRequestsOfPaymentDocumentAPI,
    getRequestsOfPaymentDocumentAPI,
    removeRequestsFromPaymentDocumentAPI,
    getAllPaymentDocumentsAPI,
    getPaymentDocumentByIdAPI,
    uploadPaymentDocumentAttachmentAPI,
    getAttachmentsOfPaymentDocumentAPI,
    downloadPaymentDocumentAttachmentAPI,
    deletePaymentDocumentAttachmentAPI,
    getAllStatusOfPaymentDocumentAPI,
    submitPaymentDocumentAPI,
    createPaymentDocumentCommentAPI,
    getPaymentDocumentCommentAPI,
    deletePaymentDocumentCommentAPI,
    getPaymentDocumentFilterOptionsAPI,
    downloadPaymentDocumentReportAPI,
    acceptPaymentDocumentReview,
    rejectPaymentDocumentReview,
    cancelPaymentDocumentProcessing,
    cancelPaymentDocument,
    approveReversalOfRequestInPaymentDocument,
    rejectReversalOfRequestInPaymentDocument,
    syncPaymentDocumentAPI,
    deletePaymentDocumentAPI,
};
